import { colors } from '@core/assistant/colors';

export const useStyles = () => {
  return {
    title: {
      color: colors.white,
      fontSize: 20,
      fontWeight: 600,
      lineHeight: 1,
    },
    sectionLabel: {
      color: colors.grey_200,
      fontSize: 11,
      fontWeight: 500,
      letterSpacing: '0.08em',
      marginTop: 1,
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 1fr)',
      gap: 1,
      marginTop: 1,
      overflowY: 'auto',
    },
    tile: (isSelected: boolean) => ({
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 0.5,
      padding: '10px 4px',
      borderRadius: 2,
      border: `1px solid ${isSelected ? colors.white : colors.grey_1}`,
      background: isSelected ? colors.white_30 : colors.white_1,
      cursor: 'pointer',

      '&:hover': {
        border: `1px solid ${colors.white}`,
        background: colors.white_1,

        '& .MuiTypography-root': {
          color: colors.white,
        },
      },
    }),
    flag: {
      fontSize: 22,
      lineHeight: 1,
    },
    code: {
      color: colors.white,
      fontSize: 11,
      fontWeight: 500,
      lineHeight: 1,
    },
  };
};
